/**
 * Class accordion
 */
class CardLinks {
	/**
	 * Constructor
	 */
	constructor() {
		this.cards = document.querySelectorAll('.block-card-link');

		this.init();
	}

	init() {
		this.cards.forEach((card) => {
			card.addEventListener('mouseenter', this.handleCardMouseOver.bind(this));
			card.addEventListener('focusin', this.handleCardMouseOver.bind(this));

			card.addEventListener('mouseleave', this.handleCardMouseOut.bind(this));
			card.addEventListener('focusout', this.handleCardMouseOut.bind(this));
		});
	}

	handleCardMouseOver(e) {
		const card = e.currentTarget;
		const textHeight = card.querySelector('.block-card-link__text').offsetHeight - 49; // 49 for padding on text.
		const titleHeight = card.querySelector('.block-card-link__title').offsetHeight;
		const innerText = card.querySelector('.block-card-link__text-inner');
		const hiddenTextHeight = card.querySelector('.block-card-link__hidden-text').offsetHeight;

		innerText.style.transform = `translateY(-${hiddenTextHeight - textHeight + titleHeight}px)`;
	}

	handleCardMouseOut(e) {
		const innerText = e.currentTarget.querySelector('.block-card-link__text-inner');

		innerText.style.transform = '';
	}
}

new CardLinks();
